import React from "react";
import "./benefits.css";

const insights = [
    {
        icon: "\u21C6", // Unicode for a transfer icon
        title: "Don’t Miss Critical Info",
        description: "Access CapEx, work orders, and partnerships instantly—data that’s buried deep in company reports, now at your fingertips."
    },
    {
        icon: "\u{1F3DB}", // Unicode for a bank building
        title: "See the Full Picture",
        description: "Get a holistic view of industries and companies, understanding financial moves, strategic shifts, and market trends."
    },
    {
        icon: "\uD83D", // Unicode for a magnifying glass
        title: "Find Insights Faster",
        description: "Save hours of research with quick access to hard-to-get financial and operational data for smarter decisions."
    }
];

const Benefits = () => {
    return (
        <div className="finance-section">
            <div className="finance-container">
                <h1 className="green-header">SMART DECISIONS
                </h1>
                <div className="finance-header-container">
                    <h2 className="finance-header">Unlock Actionable Insights for Smarter Decisions
                    </h2>
                    <p className="finance-subtext">Quickly access deep financial insights, uncover trends, and make informed decisions to stay ahead in your industry.</p>
                </div>
                <div className="finance-grid">
                    {insights.map((item, index) => (
                        <div key={index} className="finance-card">
                            <div className="finance-icon">{item.icon}</div>
                            <h3 className="finance-title">{item.title}</h3>
                            <p className="finance-description">{item.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Benefits;

